module.exports = __webpack_public_path__ + "img/map.dac3197c.png";